export default "__VITE_ASSET__wM$C5TwG__"